import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import GuestJourneyReport from '../components/GuestJourneyReport';
import { getAudit } from '../utils/storage';

export default function GuestJourneyShare() {
  const { auditId } = useParams();
  const [audit, setAudit] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const data = await getAudit(auditId);
      setAudit(data);
      setLoading(false);
    };
    load();
  }, [auditId]);

  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center"><p className="text-neutral-500 text-sm">Loading guest journey...</p></div>;
  if (!audit) return <div className="min-h-screen bg-black flex items-center justify-center"><p className="text-neutral-500 text-sm">Report not found</p></div>;

  return <GuestJourneyReport audit={audit} />;
}
